import { Diagram } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/Diagram';
import { DiagramBar } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramBar';
import { DiagramText } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/components/diagrams/DiagramText';
import { TextTone } from '@/components/modules/MerchantDetail/MerchantLenderOrchestration/types/TextTone';

export const RankingMaxProfitabilityDiagram = () => (
  <Diagram viewBox="0 0 300 100">
    <DiagramText x={34} y={14} tone={TextTone.MUTED} small anchor="start" tId="PROFITABILITY" />
    {[
      { label: 'A', width: 110, pos: '2º', win: false, y: 28 },
      { label: 'B', width: 210, pos: '1º', win: true, y: 54 },
      { label: 'C', width: 60, pos: '3º', win: false, y: 80 },
    ].map(({ label, width, pos, win, y }) => (
      <g key={label}>
        <DiagramText x={10} y={y + 10} anchor="start">
          {label}
        </DiagramText>
        <DiagramBar x={34} y={y} width={width} win={win} />
        <DiagramText x={260} y={y + 11} anchor="start" bold tone={win ? TextTone.YES : TextTone.DEFAULT}>
          {pos}
        </DiagramText>
      </g>
    ))}
  </Diagram>
);
